<script lang="ts">
  import { searchEntries } from "../lib/search";
  import SopCard from "../lib/components/SopCard.svelte";
  import CategoryPills from "../lib/components/CategoryPills.svelte";
  import { entries } from "../lib/content";

  import { onMount } from "svelte";

  let query = "";
  let inputEl: HTMLInputElement | null = null;

  onMount(() => inputEl?.focus());

  $: results = query.trim() ? searchEntries($entries, query, 50) : $entries;
</script>

<div class="flex flex-col gap-6">
  <div class="flex flex-col gap-2">
    <h1 class="text-3xl font-semibold tracking-tight">Search</h1>
    <p class="text-text-muted">Across every SOP, cheat sheet, and tag.</p>
  </div>

  <div class="panel p-3">
    <input
      bind:this={inputEl}
      bind:value={query}
      type="text"
      placeholder="Type to search..."
      class="w-full bg-transparent outline-none text-text placeholder:text-text-dim text-base px-2"
    />
  </div>

  <CategoryPills active="all" />

  {#if results.length === 0}
    <div class="panel p-8 text-center text-text-muted">No matches.</div>
  {:else}
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {#each results as sop (sop.slug)}
        <SopCard {sop} />
      {/each}
    </div>
  {/if}
</div>
